import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { usePortData } from "../../contexts/PortDataContext";

const ChartPage = () => {
  const { chartKey } = useParams(); // Get the key for the chart (e.g., "ambientTemp")
  const { liveData } = usePortData();

  // Add this object to map chartKeys to user-friendly titles
  const chartTitles = {
    thrust: "Thrust",
    ambientTemp: "Ambient Temperature",
    objectTemp: "Object Temperature",
    weight: "Weight",
    current: "Current",
    rpm: "RPM",
    dutyCycle: "Duty Cycle",
  };

  const data = useMemo(() => {
    const packetKey = {
      thrust: "thrust",
      ambientTemp: "ambientTemp",
      objectTemp: "objectTemp",
      weight: "weight",
      current: "current",
      rpm: "rpm",
      dutyCycle: "dutyCycle",
    }[chartKey];
    if (!packetKey) return [];

    return liveData
      .filter((packet) => Number.isFinite(Number(packet[packetKey])))
      .map((packet) => ({
        time: new Date(packet.time).getTime(),
        value: Number(packet[packetKey]),
      }))
      .slice(-100);
  }, [chartKey, liveData]);

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-white text-2xl mb-4">
        {chartTitles[chartKey] || chartKey} - Chart
      </h1>
      <ResponsiveContainer width="95%" height="80%">
        <LineChart data={data}>
          <Line type="monotone" dataKey="value" stroke="#FFC6C6" dot={false} />
          <CartesianGrid stroke="#ccc" />
          <XAxis
            dataKey="time"
            tickFormatter={(time) => new Date(time).toLocaleTimeString()} // Format time axis
          />
          <YAxis />
          <Tooltip />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ChartPage;
